class FamilyRelations {
  happe = false;
  kinderballe = false;
}

export default FamilyRelations;
